import { useMedia } from "use-media";
import { media } from "@nju/css";
import {
  IFtthOrchestrator,
  useOrchestrators,
} from "@nju/data-access-portal-orchestrator";
import { PaymentState } from "@nju/data-access-portal-payment";
import { IScope } from "@nju/scope";
import { SideBox } from "@nju/ui";
import { SidebarFtthPaymentDetails } from "./partials";

interface ISidebarFtthPaymentProps {
  paymentState?: PaymentState;
  state?: IFtthOrchestrator["state"] | "REACTIVATION";
  isLoading?: boolean;
  isPending: boolean;
  variant: IScope;
  ftthOrchestrator?: IFtthOrchestrator;
  promoOrchestrator?: IFtthOrchestrator;
}

export function SidebarFtthPayment({
  paymentState,
  state,
  isLoading,
  isPending,
  variant,
  promoOrchestrator,
  ftthOrchestrator,
}: ISidebarFtthPaymentProps) {
  const selectedTypeOfOrchestrator =
    state === "REACTIVATION" ? "ftthReactivation" : "ftth";
  const ftth = useOrchestrators(selectedTypeOfOrchestrator, {
    isOptional: true,
  });
  const isMobile = useMedia(media.onlyMobile);

  if (!ftth) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  const { orderSummary } = promoOrchestrator ?? ftth;

  return (
    <div data-cy="payment-box">
      {isMobile && (
        <SideBox isExpandable={true} isExpanded={false} title="opłaty">
          {({ isExpanded }) => {
            return (
              isExpanded && (
                <SidebarFtthPaymentDetails
                  ftthOrchestrator={ftthOrchestrator}
                  isLoading={isLoading}
                  isPending={isPending}
                  orderSummary={orderSummary}
                  paymentState={paymentState}
                  promoOrchestrator={promoOrchestrator}
                  state={state}
                  variant={variant}
                />
              )
            );
          }}
        </SideBox>
      )}
      {!isMobile && (
        <SideBox isExpandable={false} title="opłaty">
          <SidebarFtthPaymentDetails
            ftthOrchestrator={ftthOrchestrator}
            isLoading={isLoading}
            isPending={isPending}
            orderSummary={orderSummary}
            paymentState={paymentState}
            promoOrchestrator={promoOrchestrator}
            state={state}
            variant={variant}
          />
        </SideBox>
      )}
    </div>
  );
}
